<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row">
                <div class="col-xs-12">
                    <h1 class="h2 margin-bottom-20">{{subscription_type.name}}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-7">
                    <div class="panel panel-default margin-bottom-40">
                        <div class="panel-heading">
                            {{ $t('views.subscriptions_type_detail.title_configuration') }}
                        </div>
                        <div class="panel-body">
                            <SubscriptionTypeForm :subscription-type-prop="subscription_type" @change="onChangeSubscriptionType"></SubscriptionTypeForm>
                        </div>
                        <div class="panel-footer">
                            <a id="save-reservation-btn" class="btn btn-default btn-lg btn-block margin-bottom-10"  @click.stop.prevent="saveSubscriptionTypeClick"><i class="las la-check"></i>{{ $t('common.save_change') }}</a>
                            <a class="text-danger" href="" @click.prevent.stop="showDeleteSubscriptionTypeModal">{{ $t('views.subscriptions_type_detail.delete') }}</a>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-5">
                    <div class="row">
                        <div class="col-xs-12">
                            <h4>{{ $t('views.subscriptions_type_detail.enabled_rates') }}</h4>
                        </div>
                    </div>
                    <table class="table table-condensed">
                        <tbody>
                        <tr v-for="(rate, index) in rates_list" v-bind:key="index">
                            <td v-if="!rate.separator">
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox" :value="rate.id" v-model="subscription_type.valid_for_rates">
                                        {{ $t('views.subscriptions_type_detail.valid_rates_row', {rate_name: rate.name, duration: rate.duration_in_minutes, price: rate.price, price_currency: getCurrencySymbolFromString(rate.price_currency)}) }}
                                    </label>
                                </div>
                            </td>
                            <td v-else>
                                <div class="row margin-top-20">
                                    <div class="col-xs-7">
                                        <label>{{rate.separator_name}}</label>
                                    </div>
                                    <div class="col-xs-5 text-right">
                                        <div class="checkbox margin-0">
                                            <label>
                                                <input type="checkbox" :checked="select_checkbox[rate.separator_id]" @click="selectCheckbox(rate.separator_id, !select_checkbox[rate.separator_id])">
                                                {{ $t('views.subscriptions_type_detail.select_all') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <a class="btn btn-default" href="" @click.stop.prevent="saveValidRatesClick">
                        <i class="las la-check"></i>{{ $t('common.save_change') }}
                    </a>
                </div>
                <GenericChooseModal
                        :message="$t('views.subscriptions_type_detail.modal_delete_message')"
                        :title="$t('views.subscriptions_type_detail.delete')"
                        :visible="deleteSubscriptionTypeModalVisible"
                        :positive-button-text="$t('views.subscriptions_type_detail.modal_delete_positive')"
                        :negative-button-text="$t('views.subscriptions_type_detail.modal_delete_negative')"
                        danger
                        @positive-click-generic-modal="positiveButtonDeleteSubscriptionTypeModalClick"
                        @negative-click-generic-modal="negativeButtonDeleteSubscriptionTypeModalClick"
                        @close-generic-modal="negativeButtonDeleteSubscriptionTypeModalClick"
                />
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SubscriptionTypeForm from "../components/subscription_type/SubscriptionTypeForm";
    import {
        deleteSubscriptionType,
        getAllRates,
        getSubscriptionTypeDetail, patchSubscriptionTypeValidRates,
        updateSubscriptionTypeWithoutValidRates
    } from "../api";
    import GenericChooseModal from "../components/modal/GenericChooseModal";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {RATE_TYPE} from "@/common/constants";
    import i18n from '../i18n'
    import {Utils} from "@/common/utils";
    export default {
        title: i18n.t('views.subscriptions_type_detail.title'),
        name: "SubscriptionTypeDetail",
        components: {ContainerWithMenu, SubscriptionTypeForm, GenericChooseModal, SpinnerLoader},
        data: () => {
            return {
                loading: false,
                subscription_type: {},
                deleteSubscriptionTypeModalVisible: false,
                rates_list: [],
                select_checkbox: {}
            }
        },
        methods: {
            onChangeSubscriptionType(subscription_type) {
                this.subscription_type = subscription_type;
            },
            showDeleteSubscriptionTypeModal() {
                this.deleteSubscriptionTypeModalVisible = true
            },
            async positiveButtonDeleteSubscriptionTypeModalClick() {
                this.loading = true;
                try {
                    await deleteSubscriptionType(this.subscription_type.id);
                    this.loading = false;
                    this.deleteSubscriptionTypeModalVisible = false;
                    this.$router.push({ name: 'subscriptions_type', params: { successMessage: i18n.t('components.subscription.deletion_success') }});
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            negativeButtonDeleteSubscriptionTypeModalClick() {
                this.deleteSubscriptionTypeModalVisible = false
            },
            async saveSubscriptionTypeClick() {
                this.loading = true;
                try {
                    await updateSubscriptionTypeWithoutValidRates(
                        this.subscription_type.id,
                        this.subscription_type.name,
                        this.subscription_type.category,
                        this.subscription_type.price,
                        this.subscription_type.unlimited_renewable,
                        this.subscription_type.months_renewable,
                        this.subscription_type.unlimited_redeemable,
                        this.subscription_type.appointments_redeemable,
                        this.subscription_type.valid_for_days
                    );

                    this.loading = false;
                    this.$route.params.successMessage = i18n.t('components.subscription.updated_success');
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            async saveValidRatesClick() {
                this.loading = true;
                try {
                    await patchSubscriptionTypeValidRates(
                        this.subscription_type.id,
                        this.subscription_type.valid_for_rates,
                    );

                    this.loading = false;
                    this.$route.params.successMessage = i18n.t('components.subscription_type.valid_rates_updated');
                    window.scrollTo(0,0);
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            },
            saveRatesWithSeparator(rates) {
                console.log(rates)
                let ratesWithSeparators = [];
                for (let i = 0; i < rates.length; i++) {
                    if (i === 0) {
                        ratesWithSeparators.push({ separator_id: rates[i].type, separator: true, separator_name: Utils.getStringRateType(rates[i].type).toUpperCase()});
                    } else if (rates[i].type !== rates[i-1].type) {
                        ratesWithSeparators.push({ separator_id: rates[i].type, separator: true, separator_name: Utils.getStringRateType(rates[i].type).toUpperCase()});
                    }
                    ratesWithSeparators.push(rates[i])

                }
                this.rates_list = ratesWithSeparators;
            },
            selectCheckbox(type, value) {
                this.select_checkbox[type] = value;
                let self = this;

                if (value) {
                    this.rates_list.forEach(function (rate) {
                        if (!rate.separator && rate.type === type && !self.subscription_type.valid_for_rates.includes(rate.id)) {
                            self.subscription_type.valid_for_rates.push(rate.id);
                        }
                    });
                } else {
                    this.rates_list.forEach(function (rate) {
                        if (!rate.separator && rate.type === type && self.subscription_type.valid_for_rates.includes(rate.id)) {
                            self.subscription_type.valid_for_rates = self.subscription_type.valid_for_rates.filter(function(item) {
                                return item !== rate.id
                            })
                        }
                    });
                }
            }
        },
        async mounted() {
            this.loading = true;
            try {
                this.subscription_type = await getSubscriptionTypeDetail(this.$route.params.id);
                let rates_list = await getAllRates([RATE_TYPE.GROUP, RATE_TYPE.INDIVIDUAL]);
                this.saveRatesWithSeparator(rates_list);
                this.loading = false;
            } catch (e) {
                this.loading = false;
                console.log(e)
            }
        },
        watch: {
            rates_list: function(newVal) {
                for (let i = 0; i < newVal.length; i++) {
                    if (this.select_checkbox[newVal[i].type] === undefined && !newVal[i].separator ) {
                        let rates_list_filtered_type = this.rates_list.filter(function(item) {
                            return item.type === newVal[i].type
                        });

                        let all_rate_contained = true;

                        for (let i = 0; i < rates_list_filtered_type.length; i++) {
                            if (!this.subscription_type.valid_for_rates.includes(rates_list_filtered_type[i].id)){
                                all_rate_contained = false;
                                break
                            }
                        }

                        this.select_checkbox[newVal[i].type] = all_rate_contained
                    }
                }
            }
        }
    }
</script>
